import { Link } from "react-router-dom";
import LegalNotice from "../../components/shared/LegalNotice.jsx";

const DATENSCHUTZ_PATH = { de: "datenschutz", en: "privacy" };

const sectionTitleStyle = {
  fontFamily: "var(--font-serif)",
  fontStyle: "italic",
  fontSize: "18px",
  color: "var(--color-ink)",
  margin: 0,
};

const bodyStyle = { fontSize: "16px", lineHeight: 1.7, color: "rgba(10,9,7,0.85)", margin: 0 };
const listStyle = { display: "flex", flexDirection: "column", gap: "8px", margin: 0, paddingLeft: "20px" };

function Section({ title, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <p style={sectionTitleStyle}>{title}</p>
      {children}
    </div>
  );
}

/**
 * Real terms based on konzepte/AGB_Tales_and_Legends.docx — the bracketed
 * placeholders in that template ([Name der Organisation], [Straße,
 * Hausnummer], etc.) are filled with our real, already-established facts
 * (see Impressum.jsx/Gesellschaftsvertrag.jsx); the substantive contract
 * terms (Widerruf, Haftung, Hausrecht, ...) are transcribed as given,
 * since those are the actual terms being adopted, not gaps to fill. No
 * phone number — none exists on file, so the contact block only lists
 * the real email, same treatment as Impressum's Kontakt section.
 */
export function AgbDe() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "28px" }}>
      <p style={{ ...bodyStyle, fontFamily: "var(--font-serif)", fontSize: "16px" }}>
        Tales&amp;Legends – Veranstaltungen (LARP &amp; Theater) und Ticketverkauf
      </p>

      <Section title="1. Geltungsbereich">
        <p style={bodyStyle}>
          Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle Verträge über die Teilnahme an
          Veranstaltungen (insbesondere LARP-Events und Theaterveranstaltungen) sowie den Erwerb von Tickets, die
          zwischen Tales&amp;Legends gemeinnützige UG (haftungsbeschränkt) (nachfolgend „Veranstalter" oder
          „Tales&amp;Legends") und den Teilnehmenden bzw. Käuferinnen und Käufern von Tickets (nachfolgend
          „Teilnehmende") geschlossen werden.
        </p>
        <p style={bodyStyle}>
          Der Veranstalter ist eine gemeinnützige Organisation. Etwaige Überschüsse aus dem Ticketverkauf und der
          Durchführung von Veranstaltungen werden ausschließlich und unmittelbar für die satzungsgemäßen,
          gemeinnützigen Zwecke des Veranstalters verwendet und nicht an Mitglieder oder Dritte ausgeschüttet.
        </p>
        <p style={bodyStyle}>
          Abweichenden, entgegenstehenden oder ergänzenden Allgemeinen Geschäftsbedingungen der Teilnehmenden wird
          widersprochen; sie werden nicht Vertragsbestandteil, es sei denn, der Veranstalter stimmt ihrer Geltung
          ausdrücklich schriftlich zu.
        </p>
      </Section>

      <Section title="2. Vertragspartner">
        <p style={bodyStyle}>
          Vertragspartner ist:
          <br />
          Tales&amp;Legends gemeinnützige UG (haftungsbeschränkt)
          <br />
          Reiboldschachtring 28
          <br />
          01705 Freital
          <br />
          Vertreten durch: Geschäftsführer Nils Jäkel
          <br />
          Handelsregister: Amtsgericht Dresden, HRB 48120
          <br />
          E-Mail: <a href="mailto:hello@talesandlegends.org">hello@talesandlegends.org</a>
        </p>
      </Section>

      <Section title="3. Vertragsschluss und Ticketbuchung">
        <p style={bodyStyle}>
          Die Darstellung von Veranstaltungen und Tickets auf der Website oder in anderen Kanälen des Veranstalters
          stellt kein bindendes Angebot dar, sondern eine Aufforderung an die Teilnehmenden, ein Angebot zum Erwerb
          eines Tickets abzugeben.
        </p>
        <p style={bodyStyle}>
          Mit Absenden der Buchung (z. B. über das Online-Buchungsformular) gibt die teilnehmende Person ein
          verbindliches Angebot zum Abschluss eines Teilnahme- bzw. Ticketvertrags ab. Der Vertrag kommt zustande,
          sobald der Veranstalter die Buchung durch eine Bestätigung (z. B. per E-Mail) annimmt oder das Ticket zur
          Verfügung stellt.
        </p>
        <p style={bodyStyle}>
          Tickets sind grundsätzlich personengebunden und nur in Verbindung mit den bei der Buchung angegebenen
          Daten gültig, sofern nichts anderes angegeben ist. Eine Übertragung auf Dritte ist nur mit vorheriger
          Zustimmung des Veranstalters zulässig.
        </p>
        <p style={bodyStyle}>
          Die Anzahl der Tickets pro Veranstaltung ist begrenzt. Ein Anspruch auf Teilnahme besteht nur bei
          erfolgreicher Buchung und Zahlung innerhalb der angegebenen Frist.
        </p>
      </Section>

      <Section title="4. Preise und Zahlungsbedingungen">
        <p style={bodyStyle}>
          Es gelten die zum Zeitpunkt der Buchung angegebenen Preise. Sofern der Veranstalter als gemeinnützige
          Organisation nicht umsatzsteuerpflichtig ist bzw. die Kleinunternehmerregelung anwendet, wird dies bei der
          Preisangabe entsprechend ausgewiesen.
        </p>
        <p style={bodyStyle}>
          Die Zahlung ist grundsätzlich sofort bei Buchung über die angebotenen Zahlungsmethoden fällig, sofern im
          Einzelfall nichts anderes vereinbart wurde.
        </p>
        <p style={bodyStyle}>
          Bei Zahlungsverzug ist der Veranstalter berechtigt, die reservierte Buchung zu stornieren und das Ticket
          anderweitig zu vergeben.
        </p>
      </Section>

      <Section title="5. Widerrufsrecht">
        <p style={bodyStyle}>
          Verbraucherinnen und Verbrauchern steht bei Fernabsatzverträgen grundsätzlich ein gesetzliches
          Widerrufsrecht zu. Für Verträge zur Erbringung von Dienstleistungen im Zusammenhang mit
          Freizeitbetätigungen, bei denen sich der Vertrag auf einen bestimmten Termin oder Zeitraum bezieht (z. B.
          Veranstaltungstickets), besteht nach § 312g Abs. 2 Nr. 9 BGB jedoch kein Widerrufsrecht. Dies betrifft
          insbesondere den Erwerb von Tickets für LARP- und Theaterveranstaltungen zu einem festen Termin.
        </p>
        <p style={bodyStyle}>
          Unabhängig davon kann der Veranstalter im Einzelfall kulanzweise ein Rücktritts- oder Umbuchungsrecht
          einräumen; Einzelheiten hierzu werden bei der jeweiligen Veranstaltung gesondert kommuniziert.
        </p>
      </Section>

      <Section title="6. Durchführung, Absage, Verschiebung und Programmänderungen">
        <p style={bodyStyle}>
          Der Veranstalter ist bemüht, Veranstaltungen wie angekündigt durchzuführen. Programmänderungen (z. B.
          Änderungen der Handlung, der Besetzung, des Ablaufs oder einzelner Programmpunkte) bleiben vorbehalten,
          soweit sie den Gesamtcharakter der Veranstaltung nicht wesentlich beeinträchtigen.
        </p>
        <p style={bodyStyle}>
          Bei Absage einer Veranstaltung aus Gründen, die der Veranstalter zu vertreten hat (z. B. Ausfall ohne
          Ersatztermin), erhalten Teilnehmende den Ticketpreis erstattet oder ein Ticket für einen Ersatztermin, nach
          Wahl der Teilnehmenden.
        </p>
        <p style={bodyStyle}>
          Bei Absage oder Abbruch aufgrund höherer Gewalt, behördlicher Anordnungen, extremer Wetterbedingungen,
          Krankheit wesentlicher Mitwirkender oder vergleichbarer, vom Veranstalter nicht zu vertretender Umstände,
          richtet sich die Erstattung nach den gesetzlichen Vorgaben; ein Anspruch auf Ersatz weiterer Aufwendungen
          (z. B. Anreise-, Übernachtungs- oder Kostümkosten) besteht nicht.
        </p>
        <p style={bodyStyle}>
          Über Absagen, Verschiebungen oder wesentliche Änderungen informiert der Veranstalter die Teilnehmenden so
          früh wie möglich über die angegebenen Kontaktdaten.
        </p>
      </Section>

      <Section title="7. Pflichten der Teilnehmenden, Verhaltensregeln und Sicherheit">
        <p style={bodyStyle}>
          Die Teilnahme an LARP-Veranstaltungen und Theaterprojekten erfolgt eigenverantwortlich. Teilnehmende sind
          verpflichtet, die Sicherheits-, Haus- und Verhaltensregeln des Veranstalters sowie Anweisungen der
          Orga-/Spielleitung während der Veranstaltung zu befolgen.
        </p>
        <p style={bodyStyle}>Dazu gehören insbesondere:</p>
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Verwendung von zugelassener bzw. sicherheitsgeprüfter Ausrüstung (z. B. Waffenattrappen, Kostüme), soweit
            vom Veranstalter vorgegeben;
          </li>
          <li style={bodyStyle}>
            Rücksichtnahme auf die körperliche und psychische Unversehrtheit anderer Teilnehmender (z. B. Einhaltung
            von Safe-Words/„Time-Out"-Regeln);
          </li>
          <li style={bodyStyle}>
            Wahrheitsgemäße Angaben zu gesundheitlichen Einschränkungen, soweit für die sichere Teilnahme relevant;
          </li>
          <li style={bodyStyle}>
            Verzicht auf diskriminierendes, gewalttätiges oder anderweitig unangemessenes Verhalten gegenüber
            Mitspielenden, Mitwirkenden und Orga-Team.
          </li>
        </ul>
        <p style={bodyStyle}>
          Bei Verstößen gegen diese Regeln oder bei Gefährdung anderer Teilnehmender ist der Veranstalter berechtigt,
          Personen von der Veranstaltung auszuschließen (siehe Ziffer 10). Ein Anspruch auf (anteilige) Erstattung
          des Ticketpreises besteht in diesem Fall nicht.
        </p>
        <p style={bodyStyle}>
          Die Teilnahme an bestimmten Programmpunkten (z. B. körperlich anspruchsvollen LARP-Aktivitäten) kann eine
          ausreichende körperliche und gesundheitliche Eignung voraussetzen. Teilnehmende haben eigenverantwortlich
          zu prüfen, ob sie diese Voraussetzungen erfüllen.
        </p>
      </Section>

      <Section title="8. Haftung">
        <p style={bodyStyle}>
          Der Veranstalter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der
          Gesundheit, die auf einer vorsätzlichen oder fahrlässigen Pflichtverletzung des Veranstalters, seiner
          gesetzlichen Vertreter oder Erfüllungsgehilfen beruhen, sowie für sonstige Schäden, die auf einer
          vorsätzlichen oder grob fahrlässigen Pflichtverletzung sowie Arglist des Veranstalters beruhen.
        </p>
        <p style={bodyStyle}>
          Bei der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), deren Erfüllung die ordnungsgemäße
          Durchführung der Veranstaltung überhaupt erst ermöglicht und auf deren Einhaltung Teilnehmende regelmäßig
          vertrauen dürfen, haftet der Veranstalter auch bei leichter Fahrlässigkeit, jedoch der Höhe nach begrenzt
          auf den vertragstypisch vorhersehbaren Schaden.
        </p>
        <p style={bodyStyle}>
          Im Übrigen ist die Haftung des Veranstalters für leicht fahrlässig verursachte Schäden ausgeschlossen. Die
          Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
        </p>
        <p style={bodyStyle}>
          Teilnehmende haften für von ihnen selbst verschuldete Schäden an Personen, Ausrüstung oder Veranstaltungsort
          im Rahmen der gesetzlichen Bestimmungen. Der Abschluss einer Haftpflichtversicherung wird empfohlen; für
          bestimmte Veranstaltungen kann der Veranstalter den Nachweis einer solchen Versicherung zur Voraussetzung
          der Teilnahme machen.
        </p>
        <p style={bodyStyle}>
          Für mitgebrachte Gegenstände (z. B. Kostüme, Ausrüstung, Fahrzeuge) übernimmt der Veranstalter keine
          Haftung, soweit kein Fall der Ziffern 8.1 oder 8.2 vorliegt.
        </p>
      </Section>

      <Section title="9. Bild-, Ton- und Videoaufnahmen">
        <p style={bodyStyle}>
          Bei Veranstaltungen des Veranstalters können zu Dokumentations-, Presse- und Öffentlichkeitsarbeitszwecken
          Foto-, Video- und Tonaufnahmen angefertigt werden, auf denen auch Teilnehmende erkennbar sein können. Mit
          der Teilnahme willigen Teilnehmende in die Anfertigung und Verwendung solcher Aufnahmen im Rahmen der
          Öffentlichkeitsarbeit des Veranstalters (z. B. Website, Social Media, Presse) ein, soweit hierzu keine
          gesonderte Regelung besteht.
        </p>
        <p style={bodyStyle}>
          Teilnehmende, die nicht abgebildet werden möchten, können dies der Orga vor Beginn der Veranstaltung
          mitteilen; der Veranstalter wird sich im zumutbaren Rahmen bemühen, dem Wunsch nachzukommen, kann dies
          jedoch bei bestimmten Aufnahmesituationen (z. B. Gruppenaufnahmen im Spielgeschehen) nicht garantieren.
        </p>
        <p style={bodyStyle}>
          Ein Widerruf der Einwilligung für bereits veröffentlichtes Material ist gegenüber dem Veranstalter unter
          den angegebenen Kontaktdaten möglich; die Löschung erfolgt im Rahmen der technischen und rechtlichen
          Möglichkeiten.
        </p>
      </Section>

      <Section title="10. Hausrecht und Ausschluss von Veranstaltungen">
        <p style={bodyStyle}>
          Der Veranstalter bzw. die von ihm benannte Orga-/Spielleitung übt während der Veranstaltung das Hausrecht
          aus. Bei erheblichen Verstößen gegen diese AGB, geltendes Recht oder die Sicherheit anderer Teilnehmender
          kann ein sofortiger Ausschluss von der Veranstaltung ohne Anspruch auf Erstattung erfolgen.
        </p>
      </Section>

      <Section title="11. Gewährleistung">
        <p style={bodyStyle}>
          Es gelten die gesetzlichen Gewährleistungsvorschriften, soweit nachfolgend nichts anderes geregelt ist.
          Mängel an der Durchführung der Veranstaltung sind der Orga möglichst unverzüglich vor Ort anzuzeigen, damit
          Abhilfe geschaffen werden kann.
        </p>
      </Section>

      <Section title="12. Datenschutz">
        <p style={bodyStyle}>
          {"Der Veranstalter verarbeitet personenbezogene Daten der Teilnehmenden im Rahmen der Buchung und Durchführung der Veranstaltung gemäß den geltenden datenschutzrechtlichen Bestimmungen (insbesondere DSGVO und BDSG). Einzelheiten sind der separaten "}
          <Link to={`/de/${DATENSCHUTZ_PATH.de}`}>Datenschutzerklärung</Link>
          {" des Veranstalters zu entnehmen."}
        </p>
      </Section>

      <Section title="13. Schlussbestimmungen">
        <p style={bodyStyle}>
          Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Für Verbraucherinnen
          und Verbraucher gilt dies nur insoweit, als hierdurch der Schutz durch zwingende Bestimmungen des Rechts
          ihres gewöhnlichen Aufenthaltsortes nicht eingeschränkt wird.
        </p>
        <p style={bodyStyle}>
          Ist die teilnehmende Person Kaufmann/-frau, juristische Person des öffentlichen Rechts oder
          öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus
          diesem Vertragsverhältnis der Sitz des Veranstalters.
        </p>
        <p style={bodyStyle}>
          Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen
          Bestimmungen hiervon unberührt.
        </p>
        <p style={{ ...bodyStyle, fontSize: "13px", color: "rgba(10,9,7,0.6)" }}>Stand: 23. August 2026</p>
      </Section>
    </div>
  );
}

/** Courtesy translation — German is the legally binding version (see AgbDe). */
export function AgbEn() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "28px" }}>
      {/* Same banner as the English privacy policy, via the same component
          — the statement decides which text counts, so it must not read as
          a footnote on one page and as a notice on the other. Wording
          mirrors the privacy policy's own note (content/legal/
          privacy-policy-en.html) with the document name swapped. */}
      <LegalNotice>
        <strong>Note:</strong>
        {" This English translation is provided for informational purposes only. In the event of any discrepancy or conflict between this English version and the German version ("}
        <em>Allgemeine Geschäftsbedingungen</em>
        {"), the "}
        <strong>German version shall be legally binding</strong>
        {"."}
      </LegalNotice>
      <p style={{ ...bodyStyle, fontFamily: "var(--font-serif)", fontSize: "16px" }}>
        Tales&amp;Legends – events (LARP &amp; theater) and ticket sales
      </p>

      <Section title="1. Scope">
        <p style={bodyStyle}>
          These general terms and conditions (the "Terms") apply to all contracts for participation in events (in
          particular LARP events and theater performances) and the purchase of tickets, concluded between
          Tales&amp;Legends gemeinnützige UG (haftungsbeschränkt) (the "Organizer" or "Tales&amp;Legends") and
          participants or ticket buyers (the "Participants").
        </p>
        <p style={bodyStyle}>
          The Organizer is a non-profit organization. Any surplus from ticket sales and events is used exclusively
          and directly for the Organizer's statutory non-profit purposes and is not distributed to members or third
          parties.
        </p>
        <p style={bodyStyle}>
          Any deviating, conflicting, or supplementary terms proposed by Participants are objected to; they do not
          become part of the contract unless the Organizer expressly agrees to them in writing.
        </p>
      </Section>

      <Section title="2. Contracting party">
        <p style={bodyStyle}>
          The contracting party is:
          <br />
          Tales&amp;Legends gemeinnützige UG (haftungsbeschränkt)
          <br />
          Reiboldschachtring 28
          <br />
          01705 Freital, Germany
          <br />
          Represented by: Managing director Nils Jäkel
          <br />
          Commercial register: Amtsgericht Dresden, HRB 48120
          <br />
          Email: <a href="mailto:hello@talesandlegends.org">hello@talesandlegends.org</a>
        </p>
      </Section>

      <Section title="3. Contract formation and ticket booking">
        <p style={bodyStyle}>
          The display of events and tickets on the website or through other Organizer channels does not constitute a
          binding offer, but an invitation for Participants to submit an offer to purchase a ticket.
        </p>
        <p style={bodyStyle}>
          By submitting a booking (e.g., via the online booking form), the participating person makes a binding
          offer to enter into a participation/ticket contract. The contract is concluded once the Organizer accepts
          the booking (e.g., by email confirmation) or provides the ticket.
        </p>
        <p style={bodyStyle}>
          Tickets are generally bound to the named person and valid only together with the details provided at
          booking, unless stated otherwise. Transfer to third parties requires the Organizer's prior consent.
        </p>
        <p style={bodyStyle}>
          The number of tickets per event is limited. A right to participate exists only upon successful booking and
          payment within the specified deadline.
        </p>
      </Section>

      <Section title="4. Prices and payment terms">
        <p style={bodyStyle}>
          The prices stated at the time of booking apply. If the Organizer, as a non-profit organization, is not
          liable for VAT or applies the small-business exemption, this is indicated accordingly in the price
          display.
        </p>
        <p style={bodyStyle}>
          Payment is generally due immediately upon booking via the payment methods offered, unless otherwise agreed
          in an individual case.
        </p>
        <p style={bodyStyle}>
          In case of default of payment, the Organizer is entitled to cancel the reserved booking and offer the
          ticket to someone else.
        </p>
      </Section>

      <Section title="5. Right of withdrawal">
        <p style={bodyStyle}>
          Consumers generally have a statutory right of withdrawal for distance contracts. However, under §&nbsp;312g
          (2) no.&nbsp;9 of the German Civil Code (BGB), no right of withdrawal exists for contracts for services
          related to leisure activities where the contract specifies a particular date or period (e.g., event
          tickets). This applies in particular to tickets for LARP and theater events on a fixed date.
        </p>
        <p style={bodyStyle}>
          Regardless of this, the Organizer may, as a goodwill gesture, grant a right of cancellation or rebooking on
          a case-by-case basis; details are communicated separately for the respective event.
        </p>
      </Section>

      <Section title="6. Performance, cancellation, postponement, and program changes">
        <p style={bodyStyle}>
          The Organizer strives to hold events as announced. Program changes (e.g., changes to plot, cast,
          schedule, or individual program items) remain reserved, as long as they do not substantially affect the
          overall character of the event.
        </p>
        <p style={bodyStyle}>
          If an event is cancelled for reasons the Organizer is responsible for (e.g., cancellation without a
          replacement date), Participants receive a refund of the ticket price or a ticket for a replacement date,
          at the Participant's choice.
        </p>
        <p style={bodyStyle}>
          If an event is cancelled or aborted due to force majeure, official orders, extreme weather conditions,
          illness of key participants, or comparable circumstances beyond the Organizer's control, refunds follow
          the statutory requirements; there is no claim for reimbursement of further expenses (e.g., travel,
          accommodation, or costume costs).
        </p>
        <p style={bodyStyle}>
          The Organizer informs Participants of cancellations, postponements, or material changes as early as
          possible via the contact details provided.
        </p>
      </Section>

      <Section title="7. Participant obligations, conduct rules, and safety">
        <p style={bodyStyle}>
          Participation in LARP events and theater projects is at each Participant's own responsibility.
          Participants must follow the Organizer's safety, venue, and conduct rules, as well as instructions from
          the organizing/game-master team during the event.
        </p>
        <p style={bodyStyle}>This includes in particular:</p>
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Using approved or safety-checked equipment (e.g., prop weapons, costumes) where specified by the
            Organizer;
          </li>
          <li style={bodyStyle}>
            Respecting the physical and psychological well-being of other Participants (e.g., observing
            safe-word/"time-out" rules);
          </li>
          <li style={bodyStyle}>Providing truthful information about health conditions relevant to safe participation;</li>
          <li style={bodyStyle}>
            Refraining from discriminatory, violent, or otherwise inappropriate behavior toward fellow participants,
            contributors, and the organizing team.
          </li>
        </ul>
        <p style={bodyStyle}>
          In case of violations of these rules or endangerment of other Participants, the Organizer is entitled to
          exclude a person from the event (see clause 10). No claim to a (partial) refund of the ticket price exists
          in this case.
        </p>
        <p style={bodyStyle}>
          Participation in certain program items (e.g., physically demanding LARP activities) may require adequate
          physical and health fitness. Participants must assess for themselves whether they meet these requirements.
        </p>
      </Section>

      <Section title="8. Liability">
        <p style={bodyStyle}>
          The Organizer is liable without limitation for damages resulting from injury to life, body, or health
          caused by an intentional or negligent breach of duty by the Organizer, its legal representatives, or
          vicarious agents, as well as for other damages based on an intentional or grossly negligent breach of duty
          or fraud by the Organizer.
        </p>
        <p style={bodyStyle}>
          For breaches of material contractual obligations ("cardinal duties") whose fulfillment is essential to the
          proper execution of the event and on whose observance Participants may regularly rely, the Organizer is
          also liable for slight negligence, but limited to the foreseeable damage typical for this type of
          contract.
        </p>
        <p style={bodyStyle}>
          Beyond that, the Organizer's liability for damages caused by slight negligence is excluded. Liability
          under the Product Liability Act remains unaffected.
        </p>
        <p style={bodyStyle}>
          Participants are liable for damages to persons, equipment, or the venue that they themselves cause,
          within the scope of statutory provisions. Taking out liability insurance is recommended; for certain
          events, the Organizer may require proof of such insurance as a condition of participation.
        </p>
        <p style={bodyStyle}>
          The Organizer accepts no liability for items brought by Participants (e.g., costumes, equipment,
          vehicles), except in the cases covered by clauses 8.1 or 8.2.
        </p>
      </Section>

      <Section title="9. Photo, audio, and video recordings">
        <p style={bodyStyle}>
          Photo, video, and audio recordings may be made at the Organizer's events for documentation, press, and
          public relations purposes, on which Participants may also be recognizable. By participating, Participants
          consent to the creation and use of such recordings as part of the Organizer's public relations work (e.g.,
          website, social media, press), unless a separate arrangement exists.
        </p>
        <p style={bodyStyle}>
          Participants who do not wish to be photographed may inform the organizing team before the event begins;
          the Organizer will make reasonable efforts to accommodate this but cannot guarantee it in certain
          recording situations (e.g., group shots during gameplay).
        </p>
        <p style={bodyStyle}>
          Consent may be withdrawn for already-published material by contacting the Organizer via the contact
          details provided; removal will be carried out within technical and legal possibilities.
        </p>
      </Section>

      <Section title="10. House rules and exclusion from events">
        <p style={bodyStyle}>
          The Organizer, or the organizing/game-master team it designates, exercises house rules during the event.
          In the event of significant violations of these Terms, applicable law, or the safety of other
          Participants, immediate exclusion from the event without a right to a refund may occur.
        </p>
      </Section>

      <Section title="11. Warranty">
        <p style={bodyStyle}>
          The statutory warranty provisions apply unless otherwise stated below. Defects in the execution of the
          event should be reported to the organizing team on-site as promptly as possible so that a remedy can be
          provided.
        </p>
      </Section>

      <Section title="12. Data protection">
        <p style={bodyStyle}>
          {"The Organizer processes Participants' personal data as part of booking and running the event in accordance with applicable data protection law (in particular the GDPR and the German Federal Data Protection Act). Details can be found in the Organizer's separate "}
          <Link to={`/en/${DATENSCHUTZ_PATH.en}`}>privacy policy</Link>.
        </p>
      </Section>

      <Section title="13. Final provisions">
        <p style={bodyStyle}>
          The law of the Federal Republic of Germany applies, excluding the UN Convention on Contracts for the
          International Sale of Goods. For consumers, this applies only insofar as it does not restrict the
          protection afforded by mandatory provisions of the law of their habitual residence.
        </p>
        <p style={bodyStyle}>
          If the participating person is a merchant, a legal entity under public law, or a special fund under
          public law, the exclusive place of jurisdiction for all disputes arising from this contractual
          relationship is the Organizer's registered seat.
        </p>
        <p style={bodyStyle}>
          Should individual provisions of these Terms be or become invalid, the validity of the remaining provisions
          remains unaffected.
        </p>
        <p style={{ ...bodyStyle, fontSize: "13px", color: "rgba(10,9,7,0.6)" }}>Effective: 23 August 2026</p>
      </Section>
    </div>
  );
}
